interface NeoHeaderProps {
  message: string;
}

export const NeoHeader: React.FC<NeoHeaderProps> = ({message}) => {
  return <h4 className="text-2xl">{message}</h4>;
};
